/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root';
import { Route as OauthLoginImport } from './routes/oauth-login';
import { Route as LoginImport } from './routes/login';
import { Route as AuthImport } from './routes/_auth';
import { Route as AuthIndexImport } from './routes/_auth/index';
import { Route as AuthEnvIndexImport } from './routes/_auth/$env/index';
import { Route as AuthEnvUsersImport } from './routes/_auth/$env/users';
import { Route as AuthEnvSchedulerImport } from './routes/_auth/$env/scheduler';
import { Route as AuthEnvLocalizationImport } from './routes/_auth/$env/localization';
import { Route as AuthEnvJourneyImport } from './routes/_auth/$env/journey';
import { Route as AuthEnvCollectionsImport } from './routes/_auth/$env/collections';
import { Route as AuthEnvCloneImport } from './routes/_auth/$env/clone';
import { Route as AuthEnvExperimentsIndexImport } from './routes/_auth/$env/experiments/index';
import { Route as AuthEnvTemplatesAllImport } from './routes/_auth/$env/templates/all';
import { Route as AuthEnvTemplatesIdImport } from './routes/_auth/$env/templates/$id';
import { Route as AuthEnvExperimentsNewImport } from './routes/_auth/$env/experiments/new';
import { Route as AuthEnvExperimentsIdImport } from './routes/_auth/$env/experiments/$id';
import { Route as AuthEnvEventsSearchImport } from './routes/_auth/$env/events/search';
import { Route as AuthEnvEventsAllImport } from './routes/_auth/$env/events/all';
import { Route as AuthEnvEventsIdImport } from './routes/_auth/$env/events/$id';
import { Route as AuthEnvEventsTypeNewImport } from './routes/_auth/$env/events/$type.new';

// Create/Update Routes

const OauthLoginRoute = OauthLoginImport.update({
  id: '/oauth-login',
  path: '/oauth-login',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/oauth-login.lazy').then(d => d.Route));

const LoginRoute = LoginImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/login.lazy').then(d => d.Route));

const AuthRoute = AuthImport.update({
  id: '/_auth',
  getParentRoute: () => rootRoute,
} as any).lazy(() => import('./routes/_auth.lazy').then(d => d.Route));

const AuthIndexRoute = AuthIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthRoute,
} as any);

const AuthEnvIndexRoute = AuthEnvIndexImport.update({
  id: '/$env/',
  path: '/$env/',
  getParentRoute: () => AuthRoute,
} as any);

const AuthEnvUsersRoute = AuthEnvUsersImport.update({
  id: '/$env/users',
  path: '/$env/users',
  getParentRoute: () => AuthRoute,
} as any).lazy(() => import('./routes/_auth/$env/users.lazy').then(d => d.Route));

const AuthEnvSchedulerRoute = AuthEnvSchedulerImport.update({
  id: '/$env/scheduler',
  path: '/$env/scheduler',
  getParentRoute: () => AuthRoute,
} as any).lazy(() => import('./routes/_auth/$env/scheduler.lazy').then(d => d.Route));

const AuthEnvLocalizationRoute = AuthEnvLocalizationImport.update({
  id: '/$env/localization',
  path: '/$env/localization',
  getParentRoute: () => AuthRoute,
} as any).lazy(() => import('./routes/_auth/$env/localization.lazy').then(d => d.Route));

const AuthEnvJourneyRoute = AuthEnvJourneyImport.update({
  id: '/$env/journey',
  path: '/$env/journey',
  getParentRoute: () => AuthRoute,
} as any).lazy(() => import('./routes/_auth/$env/journey.lazy').then(d => d.Route));

const AuthEnvCollectionsRoute = AuthEnvCollectionsImport.update({
  id: '/$env/collections',
  path: '/$env/collections',
  getParentRoute: () => AuthRoute,
} as any).lazy(() => import('./routes/_auth/$env/collections.lazy').then(d => d.Route));

const AuthEnvCloneRoute = AuthEnvCloneImport.update({
  id: '/$env/clone',
  path: '/$env/clone',
  getParentRoute: () => AuthRoute,
} as any).lazy(() => import('./routes/_auth/$env/clone.lazy').then(d => d.Route));

const AuthEnvExperimentsIndexRoute = AuthEnvExperimentsIndexImport.update({
  id: '/$env/experiments/',
  path: '/$env/experiments/',
  getParentRoute: () => AuthRoute,
} as any).lazy(() => import('./routes/_auth/$env/experiments/index.lazy').then(d => d.Route));

const AuthEnvTemplatesAllRoute = AuthEnvTemplatesAllImport.update({
  id: '/$env/templates/all',
  path: '/$env/templates/all',
  getParentRoute: () => AuthRoute,
} as any).lazy(() => import('./routes/_auth/$env/templates/all.lazy').then(d => d.Route));

const AuthEnvTemplatesIdRoute = AuthEnvTemplatesIdImport.update({
  id: '/$env/templates/$id',
  path: '/$env/templates/$id',
  getParentRoute: () => AuthRoute,
} as any).lazy(() => import('./routes/_auth/$env/templates/$id.lazy').then(d => d.Route));

const AuthEnvExperimentsNewRoute = AuthEnvExperimentsNewImport.update({
  id: '/$env/experiments/new',
  path: '/$env/experiments/new',
  getParentRoute: () => AuthRoute,
} as any).lazy(() => import('./routes/_auth/$env/experiments/new.lazy').then(d => d.Route));

const AuthEnvExperimentsIdRoute = AuthEnvExperimentsIdImport.update({
  id: '/$env/experiments/$id',
  path: '/$env/experiments/$id',
  getParentRoute: () => AuthRoute,
} as any).lazy(() => import('./routes/_auth/$env/experiments/$id.lazy').then(d => d.Route));

const AuthEnvEventsSearchRoute = AuthEnvEventsSearchImport.update({
  id: '/$env/events/search',
  path: '/$env/events/search',
  getParentRoute: () => AuthRoute,
} as any).lazy(() => import('./routes/_auth/$env/events/search.lazy').then(d => d.Route));

const AuthEnvEventsAllRoute = AuthEnvEventsAllImport.update({
  id: '/$env/events/all',
  path: '/$env/events/all',
  getParentRoute: () => AuthRoute,
} as any).lazy(() => import('./routes/_auth/$env/events/all.lazy').then(d => d.Route));

const AuthEnvEventsIdRoute = AuthEnvEventsIdImport.update({
  id: '/$env/events/$id',
  path: '/$env/events/$id',
  getParentRoute: () => AuthRoute,
} as any).lazy(() => import('./routes/_auth/$env/events/$id.lazy').then(d => d.Route));

const AuthEnvEventsTypeNewRoute = AuthEnvEventsTypeNewImport.update({
  id: '/$env/events/$type/new',
  path: '/$env/events/$type/new',
  getParentRoute: () => AuthRoute,
} as any).lazy(() => import('./routes/_auth/$env/events/$type.new.lazy').then(d => d.Route));

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_auth': {
      id: '/_auth';
      path: '';
      fullPath: '';
      preLoaderRoute: typeof AuthImport;
      parentRoute: typeof rootRoute;
    };
    '/login': {
      id: '/login';
      path: '/login';
      fullPath: '/login';
      preLoaderRoute: typeof LoginImport;
      parentRoute: typeof rootRoute;
    };
    '/oauth-login': {
      id: '/oauth-login';
      path: '/oauth-login';
      fullPath: '/oauth-login';
      preLoaderRoute: typeof OauthLoginImport;
      parentRoute: typeof rootRoute;
    };
    '/_auth/': {
      id: '/_auth/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof AuthIndexImport;
      parentRoute: typeof AuthImport;
    };
    '/_auth/$env/clone': {
      id: '/_auth/$env/clone';
      path: '/$env/clone';
      fullPath: '/$env/clone';
      preLoaderRoute: typeof AuthEnvCloneImport;
      parentRoute: typeof AuthImport;
    };
    '/_auth/$env/collections': {
      id: '/_auth/$env/collections';
      path: '/$env/collections';
      fullPath: '/$env/collections';
      preLoaderRoute: typeof AuthEnvCollectionsImport;
      parentRoute: typeof AuthImport;
    };
    '/_auth/$env/journey': {
      id: '/_auth/$env/journey';
      path: '/$env/journey';
      fullPath: '/$env/journey';
      preLoaderRoute: typeof AuthEnvJourneyImport;
      parentRoute: typeof AuthImport;
    };
    '/_auth/$env/localization': {
      id: '/_auth/$env/localization';
      path: '/$env/localization';
      fullPath: '/$env/localization';
      preLoaderRoute: typeof AuthEnvLocalizationImport;
      parentRoute: typeof AuthImport;
    };
    '/_auth/$env/scheduler': {
      id: '/_auth/$env/scheduler';
      path: '/$env/scheduler';
      fullPath: '/$env/scheduler';
      preLoaderRoute: typeof AuthEnvSchedulerImport;
      parentRoute: typeof AuthImport;
    };
    '/_auth/$env/users': {
      id: '/_auth/$env/users';
      path: '/$env/users';
      fullPath: '/$env/users';
      preLoaderRoute: typeof AuthEnvUsersImport;
      parentRoute: typeof AuthImport;
    };
    '/_auth/$env/': {
      id: '/_auth/$env/';
      path: '/$env';
      fullPath: '/$env';
      preLoaderRoute: typeof AuthEnvIndexImport;
      parentRoute: typeof AuthImport;
    };
    '/_auth/$env/events/$id': {
      id: '/_auth/$env/events/$id';
      path: '/$env/events/$id';
      fullPath: '/$env/events/$id';
      preLoaderRoute: typeof AuthEnvEventsIdImport;
      parentRoute: typeof AuthImport;
    };
    '/_auth/$env/events/all': {
      id: '/_auth/$env/events/all';
      path: '/$env/events/all';
      fullPath: '/$env/events/all';
      preLoaderRoute: typeof AuthEnvEventsAllImport;
      parentRoute: typeof AuthImport;
    };
    '/_auth/$env/events/search': {
      id: '/_auth/$env/events/search';
      path: '/$env/events/search';
      fullPath: '/$env/events/search';
      preLoaderRoute: typeof AuthEnvEventsSearchImport;
      parentRoute: typeof AuthImport;
    };
    '/_auth/$env/experiments/$id': {
      id: '/_auth/$env/experiments/$id';
      path: '/$env/experiments/$id';
      fullPath: '/$env/experiments/$id';
      preLoaderRoute: typeof AuthEnvExperimentsIdImport;
      parentRoute: typeof AuthImport;
    };
    '/_auth/$env/experiments/new': {
      id: '/_auth/$env/experiments/new';
      path: '/$env/experiments/new';
      fullPath: '/$env/experiments/new';
      preLoaderRoute: typeof AuthEnvExperimentsNewImport;
      parentRoute: typeof AuthImport;
    };
    '/_auth/$env/templates/$id': {
      id: '/_auth/$env/templates/$id';
      path: '/$env/templates/$id';
      fullPath: '/$env/templates/$id';
      preLoaderRoute: typeof AuthEnvTemplatesIdImport;
      parentRoute: typeof AuthImport;
    };
    '/_auth/$env/templates/all': {
      id: '/_auth/$env/templates/all';
      path: '/$env/templates/all';
      fullPath: '/$env/templates/all';
      preLoaderRoute: typeof AuthEnvTemplatesAllImport;
      parentRoute: typeof AuthImport;
    };
    '/_auth/$env/experiments/': {
      id: '/_auth/$env/experiments/';
      path: '/$env/experiments';
      fullPath: '/$env/experiments';
      preLoaderRoute: typeof AuthEnvExperimentsIndexImport;
      parentRoute: typeof AuthImport;
    };
    '/_auth/$env/events/$type/new': {
      id: '/_auth/$env/events/$type/new';
      path: '/$env/events/$type/new';
      fullPath: '/$env/events/$type/new';
      preLoaderRoute: typeof AuthEnvEventsTypeNewImport;
      parentRoute: typeof AuthImport;
    };
  }
}

// Create and export the route tree

interface AuthRouteChildren {
  AuthIndexRoute: typeof AuthIndexRoute;
  AuthEnvCloneRoute: typeof AuthEnvCloneRoute;
  AuthEnvCollectionsRoute: typeof AuthEnvCollectionsRoute;
  AuthEnvJourneyRoute: typeof AuthEnvJourneyRoute;
  AuthEnvLocalizationRoute: typeof AuthEnvLocalizationRoute;
  AuthEnvSchedulerRoute: typeof AuthEnvSchedulerRoute;
  AuthEnvUsersRoute: typeof AuthEnvUsersRoute;
  AuthEnvIndexRoute: typeof AuthEnvIndexRoute;
  AuthEnvEventsIdRoute: typeof AuthEnvEventsIdRoute;
  AuthEnvEventsAllRoute: typeof AuthEnvEventsAllRoute;
  AuthEnvEventsSearchRoute: typeof AuthEnvEventsSearchRoute;
  AuthEnvExperimentsIdRoute: typeof AuthEnvExperimentsIdRoute;
  AuthEnvExperimentsNewRoute: typeof AuthEnvExperimentsNewRoute;
  AuthEnvTemplatesIdRoute: typeof AuthEnvTemplatesIdRoute;
  AuthEnvTemplatesAllRoute: typeof AuthEnvTemplatesAllRoute;
  AuthEnvExperimentsIndexRoute: typeof AuthEnvExperimentsIndexRoute;
  AuthEnvEventsTypeNewRoute: typeof AuthEnvEventsTypeNewRoute;
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthIndexRoute: AuthIndexRoute,
  AuthEnvCloneRoute: AuthEnvCloneRoute,
  AuthEnvCollectionsRoute: AuthEnvCollectionsRoute,
  AuthEnvJourneyRoute: AuthEnvJourneyRoute,
  AuthEnvLocalizationRoute: AuthEnvLocalizationRoute,
  AuthEnvSchedulerRoute: AuthEnvSchedulerRoute,
  AuthEnvUsersRoute: AuthEnvUsersRoute,
  AuthEnvIndexRoute: AuthEnvIndexRoute,
  AuthEnvEventsIdRoute: AuthEnvEventsIdRoute,
  AuthEnvEventsAllRoute: AuthEnvEventsAllRoute,
  AuthEnvEventsSearchRoute: AuthEnvEventsSearchRoute,
  AuthEnvExperimentsIdRoute: AuthEnvExperimentsIdRoute,
  AuthEnvExperimentsNewRoute: AuthEnvExperimentsNewRoute,
  AuthEnvTemplatesIdRoute: AuthEnvTemplatesIdRoute,
  AuthEnvTemplatesAllRoute: AuthEnvTemplatesAllRoute,
  AuthEnvExperimentsIndexRoute: AuthEnvExperimentsIndexRoute,
  AuthEnvEventsTypeNewRoute: AuthEnvEventsTypeNewRoute,
};

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren);

export interface FileRoutesByFullPath {
  '': typeof AuthRouteWithChildren;
  '/login': typeof LoginRoute;
  '/oauth-login': typeof OauthLoginRoute;
  '/': typeof AuthIndexRoute;
  '/$env/clone': typeof AuthEnvCloneRoute;
  '/$env/collections': typeof AuthEnvCollectionsRoute;
  '/$env/journey': typeof AuthEnvJourneyRoute;
  '/$env/localization': typeof AuthEnvLocalizationRoute;
  '/$env/scheduler': typeof AuthEnvSchedulerRoute;
  '/$env/users': typeof AuthEnvUsersRoute;
  '/$env': typeof AuthEnvIndexRoute;
  '/$env/events/$id': typeof AuthEnvEventsIdRoute;
  '/$env/events/all': typeof AuthEnvEventsAllRoute;
  '/$env/events/search': typeof AuthEnvEventsSearchRoute;
  '/$env/experiments/$id': typeof AuthEnvExperimentsIdRoute;
  '/$env/experiments/new': typeof AuthEnvExperimentsNewRoute;
  '/$env/templates/$id': typeof AuthEnvTemplatesIdRoute;
  '/$env/templates/all': typeof AuthEnvTemplatesAllRoute;
  '/$env/experiments': typeof AuthEnvExperimentsIndexRoute;
  '/$env/events/$type/new': typeof AuthEnvEventsTypeNewRoute;
}

export interface FileRoutesByTo {
  '/login': typeof LoginRoute;
  '/oauth-login': typeof OauthLoginRoute;
  '/': typeof AuthIndexRoute;
  '/$env/clone': typeof AuthEnvCloneRoute;
  '/$env/collections': typeof AuthEnvCollectionsRoute;
  '/$env/journey': typeof AuthEnvJourneyRoute;
  '/$env/localization': typeof AuthEnvLocalizationRoute;
  '/$env/scheduler': typeof AuthEnvSchedulerRoute;
  '/$env/users': typeof AuthEnvUsersRoute;
  '/$env': typeof AuthEnvIndexRoute;
  '/$env/events/$id': typeof AuthEnvEventsIdRoute;
  '/$env/events/all': typeof AuthEnvEventsAllRoute;
  '/$env/events/search': typeof AuthEnvEventsSearchRoute;
  '/$env/experiments/$id': typeof AuthEnvExperimentsIdRoute;
  '/$env/experiments/new': typeof AuthEnvExperimentsNewRoute;
  '/$env/templates/$id': typeof AuthEnvTemplatesIdRoute;
  '/$env/templates/all': typeof AuthEnvTemplatesAllRoute;
  '/$env/experiments': typeof AuthEnvExperimentsIndexRoute;
  '/$env/events/$type/new': typeof AuthEnvEventsTypeNewRoute;
}

export interface FileRoutesById {
  __root__: typeof rootRoute;
  '/_auth': typeof AuthRouteWithChildren;
  '/login': typeof LoginRoute;
  '/oauth-login': typeof OauthLoginRoute;
  '/_auth/': typeof AuthIndexRoute;
  '/_auth/$env/clone': typeof AuthEnvCloneRoute;
  '/_auth/$env/collections': typeof AuthEnvCollectionsRoute;
  '/_auth/$env/journey': typeof AuthEnvJourneyRoute;
  '/_auth/$env/localization': typeof AuthEnvLocalizationRoute;
  '/_auth/$env/scheduler': typeof AuthEnvSchedulerRoute;
  '/_auth/$env/users': typeof AuthEnvUsersRoute;
  '/_auth/$env/': typeof AuthEnvIndexRoute;
  '/_auth/$env/events/$id': typeof AuthEnvEventsIdRoute;
  '/_auth/$env/events/all': typeof AuthEnvEventsAllRoute;
  '/_auth/$env/events/search': typeof AuthEnvEventsSearchRoute;
  '/_auth/$env/experiments/$id': typeof AuthEnvExperimentsIdRoute;
  '/_auth/$env/experiments/new': typeof AuthEnvExperimentsNewRoute;
  '/_auth/$env/templates/$id': typeof AuthEnvTemplatesIdRoute;
  '/_auth/$env/templates/all': typeof AuthEnvTemplatesAllRoute;
  '/_auth/$env/experiments/': typeof AuthEnvExperimentsIndexRoute;
  '/_auth/$env/events/$type/new': typeof AuthEnvEventsTypeNewRoute;
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | ''
    | '/login'
    | '/oauth-login'
    | '/'
    | '/$env/clone'
    | '/$env/collections'
    | '/$env/journey'
    | '/$env/localization'
    | '/$env/scheduler'
    | '/$env/users'
    | '/$env'
    | '/$env/events/$id'
    | '/$env/events/all'
    | '/$env/events/search'
    | '/$env/experiments/$id'
    | '/$env/experiments/new'
    | '/$env/templates/$id'
    | '/$env/templates/all'
    | '/$env/experiments'
    | '/$env/events/$type/new';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/login'
    | '/oauth-login'
    | '/'
    | '/$env/clone'
    | '/$env/collections'
    | '/$env/journey'
    | '/$env/localization'
    | '/$env/scheduler'
    | '/$env/users'
    | '/$env'
    | '/$env/events/$id'
    | '/$env/events/all'
    | '/$env/events/search'
    | '/$env/experiments/$id'
    | '/$env/experiments/new'
    | '/$env/templates/$id'
    | '/$env/templates/all'
    | '/$env/experiments'
    | '/$env/events/$type/new';
  id:
    | '__root__'
    | '/_auth'
    | '/login'
    | '/oauth-login'
    | '/_auth/'
    | '/_auth/$env/clone'
    | '/_auth/$env/collections'
    | '/_auth/$env/journey'
    | '/_auth/$env/localization'
    | '/_auth/$env/scheduler'
    | '/_auth/$env/users'
    | '/_auth/$env/'
    | '/_auth/$env/events/$id'
    | '/_auth/$env/events/all'
    | '/_auth/$env/events/search'
    | '/_auth/$env/experiments/$id'
    | '/_auth/$env/experiments/new'
    | '/_auth/$env/templates/$id'
    | '/_auth/$env/templates/all'
    | '/_auth/$env/experiments/'
    | '/_auth/$env/events/$type/new';
  fileRoutesById: FileRoutesById;
}

export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren;
  LoginRoute: typeof LoginRoute;
  OauthLoginRoute: typeof OauthLoginRoute;
}

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  LoginRoute: LoginRoute,
  OauthLoginRoute: OauthLoginRoute,
};

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_auth",
        "/login",
        "/oauth-login"
      ]
    },
    "/_auth": {
      "filePath": "_auth.tsx",
      "children": [
        "/_auth/",
        "/_auth/$env/clone",
        "/_auth/$env/collections",
        "/_auth/$env/journey",
        "/_auth/$env/localization",
        "/_auth/$env/scheduler",
        "/_auth/$env/users",
        "/_auth/$env/",
        "/_auth/$env/events/$id",
        "/_auth/$env/events/all",
        "/_auth/$env/events/search",
        "/_auth/$env/experiments/$id",
        "/_auth/$env/experiments/new",
        "/_auth/$env/templates/$id",
        "/_auth/$env/templates/all",
        "/_auth/$env/experiments/",
        "/_auth/$env/events/$type/new"
      ]
    },
    "/login": {
      "filePath": "login.tsx"
    },
    "/oauth-login": {
      "filePath": "oauth-login.tsx"
    },
    "/_auth/": {
      "filePath": "_auth/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/$env/clone": {
      "filePath": "_auth/$env/clone.tsx",
      "parent": "/_auth"
    },
    "/_auth/$env/collections": {
      "filePath": "_auth/$env/collections.tsx",
      "parent": "/_auth"
    },
    "/_auth/$env/journey": {
      "filePath": "_auth/$env/journey.tsx",
      "parent": "/_auth"
    },
    "/_auth/$env/localization": {
      "filePath": "_auth/$env/localization.tsx",
      "parent": "/_auth"
    },
    "/_auth/$env/scheduler": {
      "filePath": "_auth/$env/scheduler.tsx",
      "parent": "/_auth"
    },
    "/_auth/$env/users": {
      "filePath": "_auth/$env/users.tsx",
      "parent": "/_auth"
    },
    "/_auth/$env/": {
      "filePath": "_auth/$env/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/$env/events/$id": {
      "filePath": "_auth/$env/events/$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/$env/events/all": {
      "filePath": "_auth/$env/events/all.tsx",
      "parent": "/_auth"
    },
    "/_auth/$env/events/search": {
      "filePath": "_auth/$env/events/search.tsx",
      "parent": "/_auth"
    },
    "/_auth/$env/experiments/$id": {
      "filePath": "_auth/$env/experiments/$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/$env/experiments/new": {
      "filePath": "_auth/$env/experiments/new.tsx",
      "parent": "/_auth"
    },
    "/_auth/$env/templates/$id": {
      "filePath": "_auth/$env/templates/$id.tsx",
      "parent": "/_auth"
    },
    "/_auth/$env/templates/all": {
      "filePath": "_auth/$env/templates/all.tsx",
      "parent": "/_auth"
    },
    "/_auth/$env/experiments/": {
      "filePath": "_auth/$env/experiments/index.tsx",
      "parent": "/_auth"
    },
    "/_auth/$env/events/$type/new": {
      "filePath": "_auth/$env/events/$type.new.tsx",
      "parent": "/_auth"
    }
  }
}
ROUTE_MANIFEST_END */
